import { ListItem, ListItemText } from "@mui/material";
import { IRecipientUsageDTO } from "../../services/user-role-administration-service/Models";

import type { JSX } from "react";

export type RecipientUsageListItemProps = {
    usage: IRecipientUsageDTO;
};

export default function RecipientUsageListItem({
    usage
}: RecipientUsageListItemProps): JSX.Element {
    return <ListItem
        sx={{
            marginLeft: 2
        }}>
        <ListItemText primary={usage.name} />
    </ListItem>;
}
